import {DropdownItemGroup} from "@atlaskit/dropdown-menu";
import type {ComponentProps} from "react";

export function AnankeDropdownItemGroup(props: ComponentProps<typeof DropdownItemGroup>) {
    return (
        <DropdownItemGroup {...props} />
        // <div
        //     // className="[&>div>div[data-ds--menu--heading-item='true']]:text-[0.5625rem]"
        //     style={{
        //         // "--ds-font-heading-xxsmall": "0.5625rem",
        //         // "--ds-font-heading-xxsmall": `normal 600 0.75rem/1rem ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif`,
        //     }}
        // >
        //     {/* <style dangerouslySetInnerHTML={{__html: `
        //         --ds-font-heading-xxsmall {
        //             font-size: 0.5625rem;
        //         }
        //     `}} /> */}
        //     <DropdownItemGroup {...props} />
        // </div>
    );
}
